import { colors } from '@common';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App, ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import { BrowserRouter } from 'react-router-dom';
import * as colorsTW from 'tailwindcss/colors';
import ScrollToTop from '@components/atoms/ScrollToTop/ScrollToTop';
import { CartProvider } from '@contexts';

const queryClient = new QueryClient({
  defaultOptions: {},
});

interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers = ({ children }: ProvidersProps) => (
  <QueryClientProvider client={queryClient}>
    <ConfigProvider
      locale={enUS}
      theme={{
        token: {
          fontFamily: 'Arial',
          colorPrimary: colors.primary,
          borderRadius: 0,
        },
        hashed: false,
        components: {
          Button: {
            borderRadius: 0,
            borderRadiusLG: 0,
            borderRadiusSM: 0,
            borderRadiusXS: 0,
            defaultBorderColor: 'transparent',
            defaultColor: '#000000',
            defaultBg: colors.primary,
            colorPrimaryHover: colors.primary,
            colorPrimaryActive: colors.primary,
            defaultGhostColor: colors.primary,
            defaultGhostBorderColor: colors.primary,
            fontWeight: 700,
          },
          Typography: {
            fontSize: 16,
            fontSizeLG: 18,
            fontSizeHeading1: 38,
            fontSizeHeading2: 30,
            fontSizeHeading3: 24,
            fontSizeHeading4: 20,
            fontSizeHeading5: 18,
          },
          Modal: {
            borderRadius: 8,
            titleFontSize: 16,
            contentBg: '#ffffff',
            headerBg: '#ffffff',
            footerBg: 'transparent',
          },
          Input: {
            borderRadiusLG: 4,
            borderRadius: 4,
            colorTextDisabled: colorsTW.default.gray['900'],
          },
          Select: {
            borderRadius: 4,
            borderRadiusLG: 4,
          },
          Form: {
            labelColor: colorsTW.default.gray['400'],
          },
          Tabs: {
            fontSize: 16,
          },
          Message: {
            borderRadius: 0,
            borderRadiusLG: 0,
            borderRadiusSM: 0,
          },
          Notification: {
            borderRadius: 0,
            borderRadiusLG: 0,
            borderRadiusSM: 0,
          },
        },
      }}
    >
      <App>
        <BrowserRouter>
          <CartProvider>
            <ScrollToTop />
            {children}
          </CartProvider>
        </BrowserRouter>
      </App>
    </ConfigProvider>
  </QueryClientProvider>
);
